import { render, staticRenderFns } from "./AddProviderButton.vue?vue&type=template&id=73e5df30&"
import script from "./AddProviderButton.vue?vue&type=script&lang=js&"
export * from "./AddProviderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports